import React, { useState, useEffect } from "react";
import { Edit, Trash2, Plus, RotateCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "./Car.css";

const url = process.env.REACT_APP_BACKEND_URL;

const CarList = () => {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInactive, setShowInactive] = useState(false);
  const navigate = useNavigate();

  const fetchCars = async () => {
    try {
      setLoading(true);
      const endpoint = showInactive ? `${url}/api/car/all` : `${url}/api/car`;
      const res = await axios.get(endpoint);
      setCars(res.data.data || []);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to fetch cars");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCars();
  }, [showInactive]);

  const handleSoftDelete = async (id) => {
    if (window.confirm("Are you sure you want to deactivate this car?")) {
      try {
        const res = await axios.delete(`${url}/api/car/${id}`);
        toast.success(res.data.message || "Car deactivated successfully");
        fetchCars();
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to deactivate car");
      }
    }
  };

  const handleRestore = async (id) => {
    if (window.confirm("Are you sure you want to activate this car?")) {
      try {
        const res = await axios.put(`${url}/api/car/${id}/restore`);
        toast.success(res.data.message || "Car activated successfully");
        fetchCars();
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to activate car");
      }
    }
  };

  if (loading) return <div className="loading">Loading cars...</div>;

  return (
    <div className="district-container">
      <div className="header">
        <h2>Cars List</h2>
        <div className="header-actions">
          <button
            onClick={() => setShowInactive(!showInactive)}
            className={`toggle-button ${showInactive ? 'active' : ''}`}
          >
            {showInactive ? 'Showing All' : 'Show Active Only'}
          </button>
          <button
            onClick={() => navigate("/AddCar")}
            className="add-button"
          >
            <Plus size={16} /> Add Car
          </button>
        </div>
      </div>

      <div className="district-list">
        <table>
          <thead>
            <tr>
              <th>Tarkono</th>
              <th>Car Name</th>
              <th>Owner Name</th>
              <th>Owner Phone</th>
              <th>Driver Name</th>
              <th>Driver Phone</th>
              <th>District</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {cars.length === 0 ? (
              <tr>
                <td colSpan="9" className="no-data">
                  No cars found
                </td>
              </tr>
            ) : (
              cars.map((car) => (
                <tr key={car._id} className={car.status === 'inactive' ? 'inactive-row' : ''}>
                  <td>{car.tarkono}</td>
                  <td>{car.carname}</td>
                  <td>{car.ownername}</td>
                  <td>{car.ownerphone}</td>
                  <td>{car.drivername}</td>
                  <td>{car.driverphone}</td>
                  <td>{car.district?.name || "N/A"}</td>
                  <td>
                    <span className={`status-badge ${car.status}`}>
                      {car.status === 'active' ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>
                    <div className="actions">
                      {car.status === 'active' ? (
                        <>
                          <button
                            onClick={() => navigate(`/car/edit/${car._id}`)}
                            className="edit"
                            title="Edit"
                          >
                            <Edit size={16} />
                          </button>
                          <button
                            onClick={() => handleSoftDelete(car._id)}
                            className="delete"
                            title="Deactivate"
                          >
                            <Trash2 size={16} />
                          </button>
                        </>
                      ) : (
                        <button
                          onClick={() => handleRestore(car._id)}
                          className="restore-btn"
                          title="Activate"
                        >
                          <RotateCcw size={16} /> Activate
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CarList;